import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27721c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "row header smalltext mt-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, "Skill", -1))
const _hoisted_7 = { class: "col-2" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = { class: "col-2" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ModalButton = _resolveComponent("ModalButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.useroptions)
          ? (_openBlock(), _createBlock(_component_LabeledSelect, {
              key: 0,
              label: _ctx.$t('management.grades.from'),
              options: _ctx.useroptions,
              modelValue: _ctx.grader,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.grader) = $event)),
              twoline: ""
            }, null, 8, ["label", "options", "modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.useroptions)
          ? (_openBlock(), _createBlock(_component_LabeledSelect, {
              key: 0,
              label: _ctx.$t('management.grades.to'),
              options: _ctx.useroptions,
              modelValue: _ctx.user,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user) = $event)),
              twoline: ""
            }, null, 8, ["label", "options", "modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (Object.keys(_ctx.feedbacks).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('management.grades.state')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbacks, (value, skillid) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row feedbackentry",
              key: skillid
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getSkillName(skillid)), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(value ? _ctx.$t('management.grades.done') : _ctx.$t('management.grades.open')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_ModalButton, {
                  link: `delete_feedback_${skillid}_${_ctx.grader}_${_ctx.user}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      width: 35,
                      height: 35,
                      path: _ctx.mdiDelete,
                      class: "delete"
                    }, null, 8, ["path"])
                  ]),
                  _: 2
                }, 1032, ["link"]),
                _createVNode(_component_Modal, {
                  link: `delete_feedback_${skillid}_${_ctx.grader}_${_ctx.user}`,
                  title: _ctx.$t('management.grades.modal')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('management.grades.confirm')), 1),
                    _createElementVNode("p", null, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.removeFeedback(skillid, value))
                      }, _toDisplayString(_ctx.$t('management.deleteconfirm')), 9, _hoisted_11)
                    ])
                  ]),
                  _: 2
                }, 1032, ["link", "title"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}